<template>
  <div class="no-border" v-if="address || text || spot || isExchange">
    <div v-if="text || isExchange" class="main-basic-info__retail-description">
      <p>{{ text }}</p>
      <p v-if="isExchange">
        <strong style="text-transform: none;">Skoða skipti: </strong>
        <span v-text="exchangeText"></span>
      </p>
    </div>
    <div v-if="address || spot" class="main-basic-info__parking">
      <img src="/img/parking.jpg" alt="">
      <span v-if="address">Ökutæki er á staðnum {{ address }}</span>
      <span v-else>Á staðnum</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    car: {
      type: Object,
      default: () => ({})
    },
    address: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    spot: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isExchange() {
      return this.car && (this.car.exchangeForCheaper == 1 || this.car.exchangeForExpensive == 1)
    },
    exchangeText() {
      let res = ''
      res += this.car.exchangeForCheaper == 1 ? 'Ódýrari' : '';
      res += this.car.exchangeForCheaper == 1 && this.car.exchangeForExpensive == 1 ? " / " : '';
      res += this.car.exchangeForExpensive == 1 ? 'Dýrari' : '';
      return res;
    }
  }
}
</script>
